import { MobileOnlyOptions } from "./MobileOnlyOptions";
import { USALandingOptions } from "./USALandingOptions";
import type { LandingPageConfigOptions } from "landing/objects/LandingPageConfig";

export const LandingPageTemplate19: LandingPageConfigOptions = {
  consentAge: 18,
  ...MobileOnlyOptions,
  ...USALandingOptions,
};
